var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from '@emotion/styled';
import { Flex, Skeleton, Tag, Typography, theme, } from '@robinpowered/ui-kit';
import { useEventDetailContext } from '../../context/EventDetailContextProvider';
import { useTranslation } from 'react-i18next';
import { getTagColor, getTagLabel } from '../../utils';
import { useConfig } from '../../../context/ConfigContext';
export var ServiceRequest = function (_a) {
    var _b, _c, _d, _e;
    var spaceId = _a.spaceId;
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var _f = useConfig(), environmentUrls = _f.environmentUrls, userContext = _f.userContext;
    var dashboardUrl = environmentUrls.dashboardUrl;
    var orgSlug = (_c = (_b = userContext === null || userContext === void 0 ? void 0 : userContext.currentOrg) === null || _b === void 0 ? void 0 : _b.slug) !== null && _c !== void 0 ? _c : undefined;
    var _g = useEventDetailContext(), meetingServiceRequestsDataForSpaces = _g.meetingServiceRequestsDataForSpaces, meetingServiceRequestsDataForSpacesLoading = _g.meetingServiceRequestsDataForSpacesLoading;
    var serviceRequest = useMemo(function () {
        return meetingServiceRequestsDataForSpaces === null || meetingServiceRequestsDataForSpaces === void 0 ? void 0 : meetingServiceRequestsDataForSpaces.get(spaceId);
    }, [meetingServiceRequestsDataForSpaces, spaceId]);
    if (!((_d = serviceRequest === null || serviceRequest === void 0 ? void 0 : serviceRequest.meetingServiceRequests) === null || _d === void 0 ? void 0 : _d.length)) {
        return null;
    }
    if (meetingServiceRequestsDataForSpacesLoading) {
        return _jsx(Skeleton, { active: true, paragraph: { rows: 2 } });
    }
    var serviceRequestUrl = function (key) {
        return orgSlug
            ? "".concat(dashboardUrl, "/").concat(orgSlug, "/tickets/list?serviceRequestKey=").concat(key)
            : null;
    };
    return (_jsxs(ServiceRequestWrapper, { token: token, children: [_jsx(Typography.Title, { level: 5, style: { marginBottom: 0 }, children: t('eventDetails.space.service_request') }), (_e = serviceRequest === null || serviceRequest === void 0 ? void 0 : serviceRequest.meetingServiceRequests) === null || _e === void 0 ? void 0 : _e.map(function (request) {
                var url = serviceRequestUrl(request.key);
                return (_jsxs(Flex, { justify: "space-between", align: "center", vertical: false, children: [_jsxs(Flex, { vertical: true, gap: 4, children: [url ? (_jsx(Typography.Link, { href: url, children: request.key })) : (_jsx(Typography.Text, { children: request.key })), _jsx(Typography.Text, { children: request.meetingService.name })] }), _jsx(Flex, { vertical: true, gap: 4, children: _jsx(Tag, { style: { marginInlineEnd: 4 }, color: getTagColor(request.meetingServiceRequestStatus), children: getTagLabel(request.meetingServiceRequestStatus, t) }) })] }, request.id));
            })] }));
};
var ServiceRequestWrapper = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n"], ["\n  border-top: 1px solid ", ";\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n"])), function (_a) {
    var token = _a.token;
    return token.colorBorderSecondary;
});
var templateObject_1;
